import heartReaction from "../../images/reactions/heart-reaction.gif";
import hahaReaction from "../../images/reactions/haha-reaction.gif";
import likeReaction from "../../images/reactions/like-reaction.gif";
import thanksReaction from "../../images/reactions/thanks-reaction.png";
import sadReaction from "../../images/reactions/sad-reaction.gif";
import saluteReaction from "../../images/reactions/salute-reaction.gif";
import checkReaction from "../../images/reactions/check-reaction.gif";

import fireReaction from "../../images/reactions/fire-reaction.gif";
import snakeReaction from "../../images/reactions/snake-reaction.gif";
import chainReaction from "../../images/reactions/chain-reaction.gif";
import dollarReaction from "../../images/reactions/dollar-reaction.gif";
import armyReaction from "../../images/reactions/Army.gif";
import truckReaction from "../../images/reactions/trucking.gif";
import warehouseReaction from "../../images/reactions/warehouse.gif";
import moneybagReaction from "../../images/reactions/money-bag.gif";
import roosterReaction from "../../images/reactions/rooster.gif";
import vesselReaction from "../../images/reactions/vessel.gif";

import dragonReaction from "../../images/reactions/dragon-reaction.png";
import tigerReaction from "../../images/reactions/tiger-reaction.png";

import React, { useState, useEffect, useContext } from "react";
import { ChatContext, WebSocketContext } from "../../context/contexts";
import ApiService from "../../api/apiService";
import { common } from "../../util/common";
import showSwal from "../swal";
import "../../styles/app-modal.css";

const BASE_REACTIONS = [
  { type: "checked", label: "Checked", image: checkReaction },
  { type: "heart", label: "Heart", image: heartReaction },
  { type: "haha", label: "Haha", image: hahaReaction },
  { type: "thanks", label: "Thanks", image: thanksReaction },
  { type: "like", label: "Like", image: likeReaction },
  { type: "sad", label: "Sad", image: sadReaction },
  { type: "salute", label: "Salute", image: saluteReaction },
];

const EXTRA_REACTIONS = [
  { type: "fire", label: "Fire", image: fireReaction },
  { type: "snake", label: "Snake", image: snakeReaction },
  { type: "chain", label: "Chain", image: chainReaction },
  { type: "dollar", label: "Dollar", image: dollarReaction },
  { type: "dragon", label: "Dragon", image: dragonReaction },
  { type: "tiger", label: "Tiger", image: tigerReaction },
  { type: "army", label: "Army", image: armyReaction },
  { type: "truck", label: "Truck", image: truckReaction },
  { type: "warehouse", label: "Warehouse", image: warehouseReaction },
  { type: "moneybag", label: "Money Bag", image: moneybagReaction },
  { type: "rooster", label: "Rooster", image: roosterReaction },
  { type: "vessel", label: "Vessel", image: vesselReaction },
];

function ReactionOptions({
  chat_id,
  reaction,
  userDetails,
  toggleShowReactionOptions,
}) {
  const Chat = useContext(ChatContext);
  const WS = useContext(WebSocketContext);

  const [specificReactions, setSpecificReactions] = useState(null);

  const fetchSpecificReactions = async () => {
    const specificReactionResponse =
      await ApiService.message.getUserSpecificReaction();

    if (specificReactionResponse && specificReactionResponse.success) {
      const reactions = specificReactionResponse.user_specific_reactions.map(
        (u) => u.reaction_type,
      );
      setSpecificReactions(reactions);
    }
  };

  useEffect(() => {
    fetchSpecificReactions();
  }, []);

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        toggleShowReactionOptions();
      }
    };

    const previousBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", handleEscape);

    return () => {
      document.body.style.overflow = previousBodyOverflow;
      document.removeEventListener("keydown", handleEscape);
    };
  }, [toggleShowReactionOptions]);

  const handleReactionClick = async (reactionType) => {
    if (!reactionType) return;

    const reactionResponse = await ApiService.message.addRemoveReaction(
      Chat.storedConversationId,
      chat_id,
      {
        reaction_type: reactionType,
      },
    );

    const { success, message_reaction } = reactionResponse;
    if (!success) return showSwal(common.errors.ADD_REMOVE_REACTION_ERROR);
    WS.websocketInstance.sendMsgReaction(
      { message: message_reaction, type: "user-reactions-chat" },
      Chat.storedConversationId,
    );
    toggleShowReactionOptions();
  };

  const hasReacted = (reactionType) =>
    reaction?.[reactionType]?.some(
      (reactionEntry) => reactionEntry.user_id === userDetails.id,
    );

  const availableReactions = [
    ...BASE_REACTIONS,
    ...EXTRA_REACTIONS.filter((item) => specificReactions?.includes(item.type)),
  ];

  return (
    <div
      className="modal-container app-modal-overlay reaction-picker-modal-container"
      onClick={(event) => {
        if (event.target === event.currentTarget) {
          toggleShowReactionOptions();
        }
      }}
      role="presentation"
    >
      <div className="modal-dialog app-modal-dialog reaction-picker-modal-dialog" role="dialog" aria-modal="true" aria-label="Reaction picker">
        <button
          className="close-btn reaction-picker-close-btn"
          onClick={() => toggleShowReactionOptions()}
          aria-label="Close reaction picker"
        >
          ✕
        </button>

        <div className="modal-msg-reactions reaction-picker-surface">
          <div className="reaction-picker-head">
            <h2 className="modal-title reaction-picker-title">React To Message</h2>
            <p className="reaction-title reaction-picker-subtitle">
              Pick one reaction. Selecting your current reaction removes it.
            </p>
          </div>

          <div className="reaction-icons reaction-picker-grid" aria-label="Available reactions">
            {availableReactions.map((item) => {
              const selected = hasReacted(item.type);

              return (
                <button
                  key={item.type}
                  type="button"
                  className={`reaction-icon reaction-picker-item ${
                    selected ? "reaction-picker-item--selected" : ""
                  }`}
                  onClick={() => handleReactionClick(item.type)}
                  aria-label={`${item.label} reaction`}
                  aria-pressed={selected}
                >
                  <img
                    src={item.image}
                    alt={`${item.label} reaction`}
                    className="like-reaction reaction-picker-image"
                  />
                  <small className="reaction-picker-label">{item.label}</small>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReactionOptions;
